export default __webpack_public_path__ + "static/media/twitter.9824c1c2.png";